// External Imports
import { useEffect, useState } from "react";
import Heading from "../UI/Heading";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";
import { requestAdminAPI } from "../../api/posh-api";
import { isoDateToString } from "../../util/format-date";
import { MdAdd, MdClose, MdRefresh } from "react-icons/md";
import LoadingCard from "../UI/LoadingCard";
import NoRecordsFound from "../UI/NoRecordsFound";
import Modal from "../UI/Modal";
import DetailPair from "../UI/DetailPair";
import SelectPair from "../UI/SelectPair";
import LoadingSpinner from "../UI/LoadingSpinner";
import AddBankAccount from "./AddBankAccountModal";
import BankAccountInfoModal from "./BankAccountInfoModal";

// Internal Imports

/** ========================================================================
 * * BankAccounts Component
 * This component renders a list of bank accounts under a partner.
 * ========================================================================== */

export default function BankAccounts({ partner = {} }) {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selected, setSelected] = useState(null);
  /* ====================== FETCH RECORDS ====================== */
  const fetchRecords = async () => {
    try {
      setLoading(true);
      const response = await requestAdminAPI("filter", {
        table: "account",
        filters: [`partnerId: { eq: "${partner.id}" }`],
      });
      setRecords(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) fetchRecords();
  }, [show]);

  return (
    <div className="grid">
      <AddBankAccount
        partnerId={partner.id}
        open={showAddModal}
        setOpen={setShowAddModal}
        refresh={fetchRecords}
      />
      <BankAccountInfoModal
        accountId={selected?.id}
        open={!!selected}
        setOpen={setSelected}
        refresh={fetchRecords}
      />
      <Heading
        onClick={() => setShow(!show)}
        title="Bank Accounts"
        isBackArrow={false}
      >
        <MdAdd className="icon" onClick={() => setShowAddModal(true)} />
        <MdRefresh className="icon" onClick={fetchRecords} />
        {show ? (
          <TbChevronUp className="icon" onClick={() => setShow(false)} />
        ) : (
          <TbChevronDown className="icon" onClick={() => setShow(true)} />
        )}
      </Heading>
      {show &&
        (loading ? (
          <LoadingCard columns={5} max={3} />
        ) : records.length > 0 ? (
          <div className="list">
            {records.map((account, idx) => (
              <div onClick={() => setSelected(account)} className="grid grid-cols-5 pill" key={idx}>
                <p>{isoDateToString(account.dateCreated)}</p>
                <p>{account.bank}</p>
                <p>{account.routing}</p>
                <p>{account.account}</p>
                <p>{account.type}</p>
              </div>
            ))}
          </div>
        ) : (
          <NoRecordsFound />
        ))}
    </div>
  );
}